import cn from 'classnames'
import { Form as FormikForm } from 'formik'
import { FC } from 'react'

import styles from './Form.module.scss'

interface IProps {
  className?: string
  [key: string]: any
}
const Form: FC<IProps> = ({ className, ...props }) => {
  return <FormikForm noValidate className={cn(styles.form, className)} {...props} />
}

export default Form
